import React, { useCallback, } from 'react'
import { makeStyles, } from '@material-ui/styles'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import RemoveCircleOutline from '@material-ui/icons/RemoveCircleOutline'
import ClassNameType from '@shapr/react-shared/types/ClassName'

const ListItem = props => {
  const { item, onDelete, className, ...restProps } = props
  const classes = useStyles()

  const handleDeleteClick = useCallback(() => {
    onDelete(item)
  }, [item,])

  return (
    <div className={classNames(classes.root, className)} {...restProps}>
      <Typography variant="body1" className={classes.label}>
        {item}
      </Typography>
      <IconButton onClick={handleDeleteClick} aria-label={`Remove ${item}`}>
        <RemoveCircleOutline />
      </IconButton>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    flexGrow: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}))

ListItem.propTypes = {
  className: ClassNameType,
  item: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default React.memo(ListItem)
